import { Flex, Typography } from "antd"
import FormattedMessage from "components/common/FormattedMessage";
import { useEffect, useState } from "react";
import { ReviewData } from "./Review.types";
import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { Rate } from "antd"
import AwesomeIcon from "components/common/AwesomeIcon";

interface ReviewMainPageProps {
    reviewData?: ReviewData;
    onStarsChange?: (stars: number) => void;
}

const ReviewStars = ({ onStarsChange, stars }: { onStarsChange: (stars: number) => void, stars: number }) => {

    const handleChange = (value: number) => {
        if (!value) return;
        onStarsChange && onStarsChange(value);
    }

    return (
        <Rate
            onChange={handleChange}
            character={<AwesomeIcon icon={faStar} size="2x" className="review-star" />}
            value={stars}
        />
    )

}

const ReviewMainPage = ({ reviewData, onStarsChange }: ReviewMainPageProps) => {

    const [logoError, setLogoError] = useState(false);

    return (
        <Flex vertical align="center" justify="center">
            {reviewData?.logo_url && !logoError && (
                <img
                    src={reviewData.logo_url}
                    alt="logo"
                    onError={() => setLogoError(true)}
                    style={{ width: "200px", height: "200px" }}
                />
            )}
            <Typography.Title level={1} style={{ textAlign: "center" }}>
                <FormattedMessage
                    id="standalone.reviews.welcomeMessage"
                    defaultMessage="How do you rate our service?"
                    description="Reviews: Tytuł strony głównej"
                />
            </Typography.Title>
            <ReviewStars onStarsChange={onStarsChange || (() => { })} stars={reviewData?.int_stars || 0} />
        </Flex>
    )


}

export default ReviewMainPage;